import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";

export const GEOCODER_API_KEY = window.HA_CONF.GEOCODER.API_KEY;
/**
 * Find field definitions here
 * https://developers.google.com/maps/documentation/javascript/geocoding#GeocodingAddressTypes
 */
const STREET_NUMBER_FIELDS = [
  "street_number",
  "sublocality_level_4", // Block
  "premise", // Building number
];
const STREET_FIELDS = [
  "route",
  "street_address",
  "sublocality_level_3",
  "sublocality_level_2",
];
const CITY_FIELDS = ["locality", "postal_town", "sublocality_level_1"];
const STATE_FIELDS = ["administrative_area_level_1"];
const ZIP_CODE_FIELDS = ["postal_code", "postal_code_prefix"];
const COUNTRY_FIELDS = ["country"];

const getStreet = (addressComponents) => {
  const streetComponents = [];
  const compoundSublocality = [];

  [...STREET_NUMBER_FIELDS, ...STREET_FIELDS].forEach((field, index) => {
    const fieldAddress = addressComponents.find((addressComponent) =>
      includes(addressComponent.types, field)
    );

    if (fieldAddress) {
      (includes(["sublocality_level_4", "premise"], field)
        ? compoundSublocality
        : streetComponents
      ).push(fieldAddress.long_name);
    }

    if (compoundSublocality.length && index === 2) {
      streetComponents.push(compoundSublocality.join("-"));
    }
  });

  return streetComponents.join(" ");
};

const getFieldAddress = (fieldTypesCollection, addressComponents) => {
  let fieldAddress;

  fieldTypesCollection.every((fieldType) => {
    fieldAddress = addressComponents.find((addressComponent) =>
      includes(addressComponent.types, fieldType)
    );

    return isEmpty(fieldAddress);
  });

  return fieldAddress;
};

export const parseGooglePlaceLocation = (addressComponents, stateShort) => {
  const stateComponent = getFieldAddress(STATE_FIELDS, addressComponents);

  return {
    street: getStreet(addressComponents),
    street2:
      getFieldAddress(["subpremise"], addressComponents)?.long_name || "",
    city: getFieldAddress(CITY_FIELDS, addressComponents)?.long_name || "",
    zip: getFieldAddress(ZIP_CODE_FIELDS, addressComponents)?.long_name || "",
    state: stateShort
      ? stateComponent?.short_name
      : stateComponent?.long_name || "",
    country:
      getFieldAddress(COUNTRY_FIELDS, addressComponents)?.long_name || "",
    countryCode:
      getFieldAddress(COUNTRY_FIELDS, addressComponents)?.short_name || "",
  };
};
